export default {"src":"/_next/static/media/nora-splash.e45655bf.svg","height":218,"width":277,"blurWidth":0,"blurHeight":0};